<script setup>
import { onMounted, onUnmounted, provide, reactive } from 'vue'
import { Carousel, Slide } from 'vue3-carousel'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import ButtonSetInBrand from '@/Shared/ButtonSet/ButtonSetInBrand'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Sidebar from '@/Shared/Sidebar/SidebarBannersNews/'

const props = defineProps({
  brandInfo: Array,
})

provide('data', props.brandInfo[0])

const state = reactive({
  currentSlide: 0,
})

const slideTo = (val) => {
  state.currentSlide = val
}

const handleSlideEnd = (data) => {
  // console.log('slide-end', data)
}

const addBG = (img) => 'background:url(' + replaceS3path(encodeURI(img)) + ') no-repeat center center'

onMounted(() => {})

onUnmounted(() => {})
</script>

<template>
  <div class="brand-detail">
    <div class="mx-auto px-[8vw] sm:px-[50px] sm:max-w-[550px] md:max-w-[640px] lg:max-w-[1000px] pb-[50px] sm:pb-[100px]">
      <div class="min-h-screen flex items-center">
        <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-[50px] lg:items-center pt-[30px] sm:pt-[50px] lg:py-[100px] xl:mt-0">
          <div>
            <Breadcrumbs category="brand" :title="props.brandInfo[0].brandNameLocal" class="lg:absolute lg:mt-[-55px] !flex lg:!flex !overflow-hidden" />
            <img :src="replaceS3path(props.brandInfo[0].brandThumb)" :alt="stripslashes(props.brandInfo[0].brandName)" class="mt-[40px] md:mt-[20px] mb-[20px] md:mb-[40px] max-h-[200px] mx-auto" />
            <div class="hidden lg:block">
              <h2 class="title">{{ props.brandInfo[0].brandNameLocal }}</h2>
              <p class="description">{{ stripslashes(props.brandInfo[0].brandIntroTxt) }}</p>
              <ButtonSetInBrand />
            </div>
          </div>

          <div class="flex flex-col justify-center overflow-x-hidden">
            <carousel id="gallery" v-model="state.currentSlide" :autoplay="10000" :wrap-around="true" :items-to-show="1" :transition="400" class="brand-product-slide mb-[50px]" @slide-end="handleSlideEnd">
              <slide v-for="info in props.brandInfo[0].products" :key="info">
                <div class="max-w-[500px] !bg-cover" :style="addBG(info.productImg)">
                  <img src="/img/common/placeholder600sq.png" alt="" />
                </div>
              </slide>
            </carousel>
            <ul id="thumbnails">
              <li v-for="(info, index) in props.brandInfo[0].products" :key="info.productID" :style="addBG(info.productImg)" class="!bg-[length:70%]" :class="{ active: index == state.currentSlide }">
                <img src="/img/common/placeholder600sq.png" :alt="info.productTitle" @click="slideTo(index)" />
              </li>
            </ul>
          </div>

          <div class="mt-[30px] lg:hidden">
            <h2 class="title">{{ props.brandInfo[0].brandNameLocal }}</h2>
            <p class="description">{{ stripslashes(props.brandInfo[0].brandIntroTxt) }}</p>
            <ButtonSetInBrand />
          </div>
        </div>
      </div>
      <Sidebar class="brand" category="brands" :slug="props.brandInfo[0].brandSlug" />
    </div>
  </div>
</template>
